import { jsx as tr } from "react/jsx-runtime";
import { toArray as lr } from "./helpers.js";
import { c as sr, g as or } from "../_commonjsHelpers-DaMA6jEr.js";
var U = { exports: {} };
(function(w) {
  ((L, _) => {
    w.exports ? w.exports = _() : L.fuzzysort = _();
  })(sr, (L) => {
    var _ = (a, r) => {
      if (a == "farzher")
        return { target: "farzher was here (^-^*)/", score: 0, _indexes: [0] };
      if (!a || !r)
        return g;
      var n = q(a);
      T(r) || (r = C(r));
      var i = n.bitflags;
      return (i & r._bitflags) !== i ? g : F(n, r);
    }, p = (a, r, n) => {
      if (a == "farzher")
        return [{ target: "farzher was here (^-^*)/", score: 0, _indexes: [0], obj: r ? r[0] : g }];
      if (!a)
        return n && n.all ? R(a, r, n) : K;
      var i = q(a), f = i.bitflags;
      i.containsSpace;
      var v = n && n.threshold || N, t = n && n.limit || J, e = 0, s = 0, l = r.length;
      if (n && n.key)
        for (var o = n.key, c = 0; c < l; ++c) {
          var h = r[c], u = Q(h, o);
          if (u && (T(u) || (u = C(u)), (f & u._bitflags) === f)) {
            var x = F(i, u);
            x !== g && (x.score < v || (x = { target: x.target, _targetLower: "", _targetLowerCodes: g, _nextBeginningIndexes: g, _bitflags: 0, score: x.score, _indexes: x._indexes, obj: h }, e < t ? (y.add(x), ++e) : (++s, x.score > y.peek().score && y.replaceTop(x))));
          }
        }
      else if (n && n.keys)
        for (var k = n.scoreFn || ir, V = n.keys, X = V.length, c = 0; c < l; ++c) {
          for (var h = r[c], b = new Array(X), I = 0; I < X; ++I) {
            var o = V[I], u = Q(h, o);
            if (!u) {
              b[I] = g;
              continue;
            }
            T(u) || (u = C(u)), (f & u._bitflags) !== f ? b[I] = g : b[I] = F(i, u);
          }
          b.obj = h;
          var d = k(b);
          d !== g && (d < v || (b.score = d, e < t ? (y.add(b), ++e) : (++s, d > y.peek().score && y.replaceTop(b))));
        }
      else
        for (var c = 0; c < l; ++c) {
          var u = r[c];
          if (u && (T(u) || (u = C(u)), (f & u._bitflags) === f)) {
            var x = F(i, u);
            x !== g && (x.score < v || (e < t ? (y.add(x), ++e) : (++s, x.score > y.peek().score && y.replaceTop(x))));
          }
        }
      if (e === 0)
        return K;
      for (var P = new Array(e), c = e - 1; c >= 0; --c)
        P[c] = y.poll();
      return P.total = e + s, P;
    }, S = (a, r, n) => {
      if (typeof r == "function")
        return A(a, r);
      if (a === g)
        return g;
      r === void 0 && (r = "<b>"), n === void 0 && (n = "</b>");
      var i = "", f = 0, v = !1, t = a.target, e = t.length, s = a._indexes;
      s = s.slice(0, s.len).sort((c, h) => c - h);
      for (var l = 0; l < e; ++l) {
        var o = t[l];
        if (s[f] === l) {
          if (++f, v || (v = !0, i += r), f === s.length) {
            i += o + n + t.substr(l + 1);
            break;
          }
        } else
          v && (v = !1, i += n);
        i += o;
      }
      return i;
    }, A = (l, r) => {
      if (l === g)
        return g;
      var n = l.target, i = n.length, f = l._indexes;
      f = f.slice(0, f.len).sort((h, u) => h - u);
      for (var v = "", t = 0, e = 0, s = !1, l = [], o = 0; o < i; ++o) {
        var c = n[o];
        if (f[e] === o) {
          if (++e, s || (s = !0, l.push(v), v = ""), e === f.length) {
            v += c, l.push(r(v, t++)), v = "", l.push(n.substr(o + 1));
            break;
          }
        } else
          s && (s = !1, l.push(r(v, t++)), v = "");
        v += c;
      }
      return l;
    }, j = (a) => a._indexes.slice(0, a._indexes.len).sort((r, n) => r - n), $ = (a) => {
      typeof a != "string" && (a = "");
      var r = D(a);
      return { target: a, _targetLower: r._lower, _targetLowerCodes: r.lowerCodes, _nextBeginningIndexes: g, _bitflags: r.bitflags, score: g, _indexes: [0], obj: g };
    }, Z = (a) => {
      typeof a != "string" && (a = ""), a = a.trim();
      var r = D(a), n = [];
      if (r.containsSpace) {
        var i = a.split(/\s+/);
        i = [...new Set(i)];
        for (var f = 0; f < i.length; f++)
          if (i[f] !== "") {
            var v = D(i[f]);
            n.push({ lowerCodes: v.lowerCodes, _lower: i[f].toLowerCase(), containsSpace: !1 });
          }
      }
      return { lowerCodes: r.lowerCodes, bitflags: r.bitflags, containsSpace: r.containsSpace, _lower: r._lower, spaceSearches: n };
    }, C = (a) => {
      if (a.length > 999)
        return $(a);
      var r = G.get(a);
      return r !== void 0 || (r = $(a), G.set(a, r)), r;
    }, q = (a) => {
      if (a.length > 999)
        return Z(a);
      var r = H.get(a);
      return r !== void 0 || (r = Z(a), H.set(a, r)), r;
    }, R = (a, r, n) => {
      var i = [];
      i.total = r.length;
      var f = n && n.limit || J;
      if (n && n.key)
        for (var v = 0; v < r.length; v++) {
          var t = r[v], e = Q(t, n.key);
          if (e) {
            T(e) || (e = C(e)), e.score = N, e._indexes.len = 0;
            var s = e;
            if (s = { target: s.target, _targetLower: "", _targetLowerCodes: g, _nextBeginningIndexes: g, _bitflags: 0, score: e.score, _indexes: g, obj: t }, i.push(s), i.length >= f)
              return i;
          }
        }
      else if (n && n.keys)
        for (var v = 0; v < r.length; v++) {
          for (var t = r[v], l = new Array(n.keys.length), o = n.keys.length - 1; o >= 0; --o) {
            var e = Q(t, n.keys[o]);
            if (!e) {
              l[o] = g;
              continue;
            }
            T(e) || (e = C(e)), e.score = N, e._indexes.len = 0, l[o] = e;
          }
          if (l.obj = t, l.score = N, i.push(l), i.length >= f)
            return i;
        }
      else
        for (var v = 0; v < r.length; v++) {
          var e = r[v];
          if (e && (T(e) || (e = C(e)), e.score = N, e._indexes.len = 0, i.push(e), i.length >= f))
            return i;
        }
      return i;
    }, F = (a, r, n = !1) => {
      if (n === !1 && a.containsSpace)
        return rr(a, r);
      for (var i = a._lower, f = a.lowerCodes, v = f[0], t = r._targetLowerCodes, e = f.length, s = t.length, h = 0, l = 0, o = 0; ; ) {
        var c = v === t[l];
        if (c) {
          if (B[o++] = l, ++h, h === e)
            break;
          v = f[h];
        }
        if (++l, l >= s)
          return g;
      }
      var h = 0, u = !1, x = 0, k = r._nextBeginningIndexes;
      k === g && (k = r._nextBeginningIndexes = ar(r.target)), l = B[0] === 0 ? 0 : k[B[0] - 1];
      var V = 0;
      if (l !== s)
        for (; ; )
          if (l >= s) {
            if (h <= 0 || (++V, V > 200))
              break;
            --h;
            var X = M[--x];
            l = k[X];
          } else {
            var c = f[h] === t[l];
            if (c) {
              if (M[x++] = l, ++h, h === e) {
                u = !0;
                break;
              }
              ++l;
            } else
              l = k[l];
          }
      var b = r._targetLower.indexOf(i, B[0]), I = ~b;
      if (I && !u)
        for (var d = 0; d < o; ++d)
          B[d] = b + d;
      var P = !1;
      I && (P = r._nextBeginningIndexes[b - 1] === b);
      {
        if (u)
          var m = M, W = x;
        else
          var m = B, W = o;
        for (var z = 0, O = 0, d = 1; d < e; ++d)
          m[d] - m[d - 1] !== 1 && (z -= m[d], ++O);
        var vr = m[e - 1] - m[0] - (e - 1);
        if (z -= (12 + vr) * O, m[0] !== 0 && (z -= m[0] * m[0] * 0.2), !u)
          z *= 1e3;
        else {
          for (var Y = 1, d = k[0]; d < s; d = k[d])
            ++Y;
          Y > 24 && (z *= (Y - 24) * 10);
        }
        I && (z /= 1 + e * e * 1), P && (z /= 1 + e * e * 1), z -= s - e, r.score = z;
        for (var d = 0; d < W; ++d)
          r._indexes[d] = m[d];
        return r._indexes.len = W, r;
      }
    }, rr = (a, r) => {
      for (var n = /* @__PURE__ */ new Set(), i = 0, f = g, v = 0, t = a.spaceSearches, o = 0; o < t.length; ++o) {
        var e = t[o];
        if (f = F(e, r), f === g)
          return g;
        i += f.score, f._indexes[0] < v && (i -= v - f._indexes[0]), v = f._indexes[0];
        for (var s = 0; s < f._indexes.len; ++s)
          n.add(f._indexes[s]);
      }
      var l = F(
        a,
        r,
        /*allowSpaces=*/
        !0
      );
      if (l !== g && l.score > i)
        return l;
      f.score = i;
      var o = 0;
      for (let c of n)
        f._indexes[o++] = c;
      return f._indexes.len = o, f;
    }, D = (a) => {
      for (var r = a.length, n = a.toLowerCase(), i = [], f = 0, v = !1, t = 0; t < r; ++t) {
        var e = i[t] = n.charCodeAt(t);
        if (e === 32) {
          v = !0;
          continue;
        }
        var s = e >= 97 && e <= 122 ? e - 97 : e >= 48 && e <= 57 ? 26 : e <= 127 ? 30 : 31;
        f |= 1 << s;
      }
      return { lowerCodes: i, bitflags: f, containsSpace: v, _lower: n };
    }, er = (a) => {
      for (var r = a.length, n = [], i = 0, f = !1, v = !1, t = 0; t < r; ++t) {
        var e = a.charCodeAt(t), s = e >= 65 && e <= 90, l = s || e >= 97 && e <= 122 || e >= 48 && e <= 57, o = s && !f || !v || !l;
        f = s, v = l, o && (n[i++] = t);
      }
      return n;
    }, ar = (a) => {
      for (var r = a.length, n = er(a), i = [], f = n[0], v = 0, t = 0; t < r; ++t)
        f > t ? i[t] = f : (f = n[++v], i[t] = f === void 0 ? r : f);
      return i;
    }, nr = () => {
      G.clear(), H.clear(), B = [], M = [];
    }, G = /* @__PURE__ */ new Map(), H = /* @__PURE__ */ new Map(), B = [], M = [], ir = (a) => {
      for (var r = N, n = a.length, i = 0; i < n; ++i) {
        var f = a[i];
        if (f !== g) {
          var v = f.score;
          v > r && (r = v);
        }
      }
      return r === N ? g : r;
    }, Q = (a, r) => {
      var n = a[r];
      if (n !== void 0)
        return n;
      var i = r;
      Array.isArray(r) || (i = r.split("."));
      for (var f = i.length, v = -1; a && ++v < f; )
        a = a[i[v]];
      return a;
    }, T = (a) => typeof a == "object", J = 1 / 0, N = -J, K = [];
    K.total = 0;
    var g = null, fr = (a) => {
      var r = [], n = 0, i = {}, f = (v) => {
        for (var t = 0, e = r[t], s = 1; s < n; ) {
          var l = s + 1;
          t = s, l < n && r[l].score < r[s].score && (t = l), r[t - 1 >> 1] = r[t], s = 1 + (t << 1);
        }
        for (var o = t - 1 >> 1; t > 0 && e.score < r[o].score; o = (t = o) - 1 >> 1)
          r[t] = r[o];
        r[t] = e;
      };
      return i.add = (v) => {
        var t = n;
        r[n++] = v;
        for (var e = t - 1 >> 1; t > 0 && v.score < r[e].score; e = (t = e) - 1 >> 1)
          r[t] = r[e];
        r[t] = v;
      }, i.poll = (v) => {
        if (n !== 0) {
          var t = r[0];
          return r[0] = r[--n], f(), t;
        }
      }, i.peek = (v) => {
        if (n !== 0)
          return r[0];
      }, i.replaceTop = (v) => {
        r[0] = v, f();
      }, i;
    }, y = fr();
    return { single: _, go: p, highlight: S, prepare: $, indexes: j, cleanup: nr };
  });
})(U);
var gr = U.exports;
const E = /* @__PURE__ */ or(gr), _r = (w, L = !1) => {
  var p, S;
  const _ = lr(w);
  return L ? _.map((A) => (A == null ? void 0 : A.value) ?? (A == null ? void 0 : A.label)) : ((p = _[0]) == null ? void 0 : p.value) ?? ((S = _[0]) == null ? void 0 : S.label);
}, wr = (w, L) => {
  const _ = E.single(w, L);
  if (!_)
    return;
  const p = E.indexes(_);
  return p[0] !== 0 ? [0, L.length] : [
    Math.max(...p.map((S) => S.valueOf())) + 1,
    L.length
  ];
}, ur = (w, L, _ = "b") => E.highlight(
  E.single(L, w),
  (p, S) => /* @__PURE__ */ tr(_, { children: p }, S)
) || w, cr = (w, L, _) => ({
  ...w,
  formattedLabel: ur(w.label, L, _)
}), Lr = (w, L, _) => E.go(w, L, {
  key: "label",
  limit: _,
  threshold: -5e3
}).map((S) => cr(S.obj, w));
export {
  wr as getQueryRangeExclusive,
  _r as getValueFromLabelValues,
  ur as highlightQueryInLabel,
  cr as highlightQueryInLabelValue,
  Lr as searchLabelValues
};
